import { PlusCircleIcon } from '@heroicons/react/24/outline';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DrawerComponent } from 'src/components/DialogComponent';
import { DownloadIcon } from 'src/components/ui-icons/upload';
import TGButton from 'src/components/ui/TGButton';
import { FlexCol } from 'src/utils/flexLayouts';
import { TooltipItem } from 'src/utils/Tooltip';
import AddActionGop from '../formAddActionGop/AddActionGop';
import FilterForPlanAction from 'src/pages/DashboardPage/vpo/components/planAction/filterForPlanAction/FilterForPlanAction';
import { isEqual } from 'lodash';
import { filterConfigGOS, filtersOpen, initialFilter } from './FiltersPLanAction';
import { focusGops } from '../../mocks/planAction/FiltersData';
import ContentGop from '../contentPlanActionGop/ContentGop';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectModelData } from '../../selectors/selectors';
import { clearModelData, fetchData } from '../../actions/actions';
import { selectItems } from 'src/modules/spItems/selectors';
import { myTaskActionsListName, myTaskActionsStatusesListName } from 'src/api/config/myTasksActions.config';
import { myTaskMeetingsListName } from 'src/api/config/meetings.config';
import { getItems } from 'src/modules/spItems/actions';
import AddCommentGop from '../addComment/AddCommentGop';
import ExportToExcelGOP from '../exportToExcelGOP/ExportToExcelGOP';
import { Quarter, UniversalObject } from '../../types/data';

interface PlanActionsContext {
  selectedGroup: UniversalObject | null;
  selectedFactory: UniversalObject;
  selectedGop: UniversalObject;
  currentQuarter: Quarter | null;
  currentYear: number | null;
}

interface PlanActionsProps {
  context: PlanActionsContext;
}

export default function PlanActions({ context }: PlanActionsProps) {
  const [open, setOpen] = useState(false);
  const [currentFilters, setCurrentFilters] = useState<any>(initialFilter);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [actionsData, setActionsData] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const dataDirection = useAppSelector((state: any) => selectModelData(state, 'gop-directions'));
  const dataBlock = useAppSelector((state: any) => selectModelData(state, 'gop-blocks'));
  const dataDemands = useAppSelector((state: any) => selectModelData(state, 'gop-requirements'));
  const statuses = useAppSelector((state) => selectItems(state, myTaskActionsStatusesListName).filter((status) => status.Color !== ''));

  const meetings = useAppSelector((state) => {
    const allMeetings = selectItems(state, myTaskMeetingsListName);
    const vpoActions = selectItems(state, myTaskActionsListName);
    const meetingIds = vpoActions.map((action) => action.Meeting?.ID).filter(Boolean);
    return allMeetings.filter((meeting) => meetingIds.includes(meeting.ID));
  });
  //! получаю направления по форме гоп
  useEffect(() => {
    //! Сброс фильтров при смене GOP
    dispatch(clearModelData('gop-directions'));
    dispatch(clearModelData('gop-blocks'));
    dispatch(clearModelData('gop-requirements'));

    setCurrentFilters(initialFilter);

    const selectedGopIds = context.selectedGop?.id;
    if (selectedGopIds) {
      dispatch(fetchData('gop-directions', { gop: selectedGopIds }));
    }
  }, [dispatch, context.selectedGop?.id]);
  //! получаю блоки по выбранному направлению
  useEffect(() => {
    const selectedDirectionIds = currentFilters?.direction?.selectedIds;
    if (selectedDirectionIds && selectedDirectionIds.length > 0) {
      dispatch(fetchData('gop-blocks', { direction: selectedDirectionIds }));
    } else {
      dispatch(clearModelData('gop-blocks'));
    }
  }, [dispatch, currentFilters?.direction?.selectedIds]);
  //! получаю требования по выбранному блоку
  useEffect(() => {
    const selectedBlockIds = currentFilters?.block?.selectedIds;
    if (selectedBlockIds && selectedBlockIds.length > 0) {
      dispatch(fetchData('gop-requirements', { block: selectedBlockIds }));
    } else {
      dispatch(clearModelData('gop-requirements'));
    }
  }, [dispatch, currentFilters?.block?.selectedIds]);

  useEffect(() => {
    dispatch(getItems({ listName: myTaskMeetingsListName }));
    dispatch(
      getItems({
        listName: myTaskActionsListName,
        filters: { ImportantHashTag: `#${'GOPСтандарты'}*` },
      })
    );
  }, [dispatch]);

  const toggleDoing = (value: boolean) => {
    setOpen(value);
  };

  const handleActionAdded = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  const handleFiltersChange = useCallback(
    (newFilters: React.SetStateAction<any>) => {
      if (!isEqual(currentFilters, newFilters)) {
        console.log('Новые фильтры ОТЧЕТЫ:', newFilters);
        setCurrentFilters(newFilters);
      }
    },
    [currentFilters]
  );

  const handleDataUpdate = useCallback((data: any[]) => {
    setActionsData(data);
  }, []);

  const filterConfigs = useMemo(
    () => ({
      direction: { items: dataDirection },
      block: { items: dataBlock },
      demandGop: { items: dataDemands },
      focusGop: { items: focusGops },
      status: { items: statuses },
      meeting: { items: meetings },
    }),
    [dataDirection, dataBlock, dataDemands, focusGops, statuses, meetings]
  );

  const filtersMap = useMemo(
    () => ({
      direction: dataDirection,
      block: dataBlock,
      demandGop: dataDemands,
      focusGop: focusGops,
      status: statuses,
      meeting: meetings,
    }),
    [dataDirection, dataBlock, dataDemands, focusGops, statuses, meetings]
  );

  return (
    <div className='flex justify-between m-2'>
      <div className='w-[320px] mr-2'>
        <FilterForPlanAction
          key={context.selectedGop?.id}
          onFiltersChange={handleFiltersChange}
          filterConfigs={filterConfigs}
          filtersMap={filtersMap}
          initialFilters={initialFilter}
          filtersOpen={filtersOpen}
          filtersConfig={filterConfigGOS}
          responsibleFil={true}
          heightFilter={'h-[calc(100vh-160px)]'}
        />
      </div>
      <div className='flex-1 flex flex-col min-w-0'>
        <div className='flex mb-2'>
          <div className='flex-1 mr-2'>
            <TGButton icon={<PlusCircleIcon width={20} height={20} />} onClick={() => toggleDoing(true)} color='white' className='w-full'>
              Добавить действие
            </TGButton>
            <DrawerComponent open={open} zIndex={50} percentage='87' toggleDrawer={closeDialog}>
              <FlexCol className='p-10'>
                <h1 className='mb-8 text-black'>Действия</h1>
                <AddActionGop toggleDoing={toggleDoing} onActionAdded={handleActionAdded} context={context} />
              </FlexCol>
            </DrawerComponent>
            {/*  <DrawerComponent open={open} zIndex={50} percentage='87' toggleDrawer={closeDialog}>
              <FlexCol className='p-10'>
                <h1 className='mb-8 text-black'>Комментарий</h1>
                <AddCommentGop toggleDoing={toggleDoing} />
              </FlexCol>
            </DrawerComponent> */}
          </div>
          <TooltipItem position='left' tooltipsText={'Экспорт в Excel'}>
            <ExportToExcelGOP data={actionsData} />
          </TooltipItem>
        </div>
        <div className='flex-1 min-w-0'>
          <ContentGop filters={currentFilters} refreshTrigger={refreshTrigger} onDataUpdate={handleDataUpdate} context={context} />
        </div>
      </div>
    </div>
  );
}
